import { get } from 'lodash-es';

/**
 * Initialize State by sorting data transform
 * @param {*} param0
 */
export const initializeState = ({ data }) => {
  try {
    const newData = {
      documents: [], // get(data, 'documents'),
      contracts: get(data, 'contracts', []),
    };

    const state = {
      data: newData,
      codeFirstError: undefined,
    };

    return state;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`initializeState: ${e.stack}`);
  }
  return [];
};
